import styled, { css } from 'styled-components';
import device from 'utils/device';

export const InitialsWrapper = styled.div`
  ${({ theme }) => css`
    display: flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background-color: ${theme.colour.primary};

    font-size: 14px;
    font-weight: 600;
    letter-spacing: 0.1px;
    color: #FFFFFF;

    @media ${device.tablet} {
      font-size: 22px;
      width: 48px;
      height: 48px;
    }
  `}
`;
